import { useScrollAnimation } from "../../../hooks/useScrollAnimation";
import { features } from "../../../mocks/homeData";

export default function Features() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section id="features" className="bg-gray-100 py-12 md:py-16">
      <div
        ref={ref}
        className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8"
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-0">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`flex flex-col items-center text-center px-4 md:px-8 py-4 md:py-0 ${
                index < features.length - 1 ? "lg:border-r lg:border-gray-300" : ""
              } ${isVisible ? "animate-fade-up" : "opacity-0"}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mb-3 md:mb-4 text-copper group-hover:rotate-[15deg] transition-transform duration-300">
                <i className={`${feature.icon} text-3xl md:text-4xl`} />
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-navy mb-1 md:mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-xs md:text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}